var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 43"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.460938,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F0F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "business_messages"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_2589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 41
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 20,
    y: 20.4609,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_2589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "business_messages_2",
    d: "M31.6666 53.7956C30.75 53.7956 29.9652 53.4692 29.3125 52.8164C28.6597 52.1636 28.3333 51.3789 28.3333 50.4622V35.0456L22.8333 28.5039C22.6111 28.2261 22.5694 27.9275 22.7083 27.6081C22.8472 27.2886 23.0972 27.1289 23.4583 27.1289H53.3333C54.25 27.1289 55.0347 27.4553 55.6875 28.1081C56.3402 28.7609 56.6666 29.5456 56.6666 30.4622V50.4622C56.6666 51.3789 56.3402 52.1636 55.6875 52.8164C55.0347 53.4692 54.25 53.7956 53.3333 53.7956H31.6666ZM31.6666 30.4622V50.4622H53.3333V30.4622H31.6666ZM43 45.4622H48.3333C48.8055 45.4622 49.2014 45.3025 49.5208 44.9831C49.8402 44.6636 50 44.2678 50 43.7956C50 43.3234 49.8402 42.9275 49.5208 42.6081C49.2014 42.2886 48.8055 42.1289 48.3333 42.1289H39.0416C38.2916 42.1289 37.7708 42.4692 37.4791 43.1497C37.1875 43.8303 37.3055 44.4345 37.8333 44.9622L41.3333 48.4622C41.6389 48.7678 42.0277 48.9206 42.5 48.9206C42.9722 48.9206 43.3611 48.7678 43.6666 48.4622C43.9722 48.1567 44.125 47.7678 44.125 47.2956C44.125 46.8234 43.9722 46.4345 43.6666 46.1289L43 45.4622ZM42 35.4622H36.6666C36.1944 35.4622 35.7986 35.622 35.4791 35.9414C35.1597 36.2609 35 36.6567 35 37.1289C35 37.6011 35.1597 37.997 35.4791 38.3164C35.7986 38.6359 36.1944 38.7956 36.6666 38.7956H45.9583C46.7083 38.7956 47.2291 38.4553 47.5208 37.7747C47.8125 37.0942 47.6944 36.49 47.1666 35.9622L43.6666 32.4622C43.3611 32.1567 42.9722 32.0039 42.5 32.0039C42.0277 32.0039 41.6389 32.1567 41.3333 32.4622C41.0277 32.7678 40.875 33.1567 40.875 33.6289C40.875 34.1011 41.0277 34.49 41.3333 34.7956L42 35.4622Z",
    fill: "#7E8488"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.202eaa3076535ff118563d6b73ac5186.svg";
export { ForwardRef as ReactComponent };